// Description: This screen will show all inventory items that are low in stock

import React, { useEffect } from 'react'
import { Container, Table, Alert, Row, Col, Button } from 'react-bootstrap'
import LowInventoryUnit from '../components/LowInventoryUnit'
import { getLowInventory } from '../actions/reportActions'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, useParams, Link } from 'react-router-dom'
import Loader from '../components/Loader'
import Message from '../components/Message'
import PaginateLow from '../components/Paginate'

const LowInventory = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { lowpageNumber } = useParams() || 1

  const lowInventory = useSelector((state) => state.lowInventory)
  const { loading, error, lowinventory, lowpage, lowpages, lowcount } =
    lowInventory

  // Sort the array by manufacturer
  lowinventory.sort((a, b) => (a.manufacturer > b.manufacturer ? 1 : -1))

  // Remove duplicate items from the array
  const uniqueObjects = [
    ...new Map(lowinventory.map((element) => [element._id, element])).values()
  ]

  // Use effect for pagenumber change
  useEffect(() => {
    dispatch(getLowInventory(lowpageNumber))
  }, [dispatch, navigate, lowpageNumber])

  return (
    <Container className='my-3'>
      <PaginateLow pages={lowpages} page={lowpage} />
      <Row className='align-items-center'>
        <Col>
          <h3>Low Inventory by Manufacturer</h3>
        </Col>
        <Col className='text-right'>
          <Button
            size='sm'
            className='my-3'
            variant='outline-primary'
            onClick={() => window.print()}
          >
            Print Report
          </Button>
        </Col>
        <Col>
          <Button size='sm' variant='outline' className='my-3'>
            <Link to='/reports'>Go Back</Link>
          </Button>
        </Col>
      </Row>

      {alert.show && <Alert variant={alert.variant}>{alert.message}</Alert>}
      {lowcount === 0 && <Message variant='info'>None Found</Message>}
      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error}</Message>
      ) : (
        <Table striped bordered hover responsive className='table-sm'>
          <thead>
            <tr>
              <th>UPC</th>
              <th>Item</th>
              <th>Manufacturer</th>
              <th>Subname</th>
              <th>Qty</th>
              <th>Low</th>
              <th>Price</th>
              <th>Last Update</th>
              <th>UPD</th>
            </tr>
          </thead>
          <tbody>
            {uniqueObjects.map((unit) => (
              <LowInventoryUnit key={unit._id} unit={unit} />
            ))}
          </tbody>
        </Table>
      )}
    </Container>
  )
}

export default LowInventory
